<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      // padding: '10px',
      // paddingTop: '0px',
      // paddingTop: '20px',
      // position: 'relative',
      // bottom: '20px',
      minHeight: '100vh',
      height: 'auto'
    }"
    id="game-zone"
  >
    <!-- <header-o :model="headerData"></header-o> -->
    <div
      class="padding-5"
      style="height: 200px;"
      :style="{
        backgroundColor: isDarkTheme ? topBgColor : bgTheme,
        borderBottomLeftRadius: '10px',
        borderBottomRightRadius: '10px',marginTop:'-20px'
      }"
    ></div>
    <div style="padding: 10px;margin-top: -190px" v-if="allTournaments.length">
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
          cursor: 'pointer',
          borderRadius: '10px'
        }"
        class="bg-light align-ver radius-3 padding-10 box-shadow margin-bottom-10"
        v-for="tour in allTournaments"
        @click="redirectTo('tournament', tour.params)"
      >
        <div class="pos-rel margin-bottom-10">
          <img class="full-width game-banner" :src="tour.game_banner" />
          <div
            class="live-timer bg-red pos-abs text-light font-bold padding-10"
          >
            <span>{{
              tour.is_live
                ? getTranslatedText("LIVE")
                : getTranslatedText("Starts")
            }}</span
            ><br /><span class="text-small"
              >{{
                tour.is_live
                  ? getTranslatedText("Ends")
                  : getTranslatedText("In")
              }}: <span :id="'tr_timer_' + tour.id"></span
            ></span>
          </div>
        </div>
        <div class="align-hor center-ver space-between">
          <div class="text-left">
            <div class="font-bold margin-bottom-5" style="color: #323232;">{{ tour.title }}</div>
            <div class="align-hor center-ver" style="font-size: 12px; color: #9A9A9A;">
              Total Prize:
              <img
              style="width: 14px; height: 12px;"
                class=" padding-vertical-5"
                :src="tour.prize_icon_url"
              />
              <!-- {{ formatReward(tour.prize_type, tour.total_prize, true) }} -->
              {{ tour.total_prize }}
            </div>
          </div>
          <div>
            <!-- <button class="custom-button small text-light padding-0520 radius-30" :style="{background: bgTheme}" @click="redirectTo('tournament', tour.params)">Play</button> -->
            <button
              class="custom-button small"
              :style="{
                background: isDarkTheme ? buttonBGColor : bgTheme,
                color: isDarkTheme ? headingTextColor : '#ffffff',
                borderRadius: '25px', padding:'8px 20px'
              }"
            >
              PLAY
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      style="height: 90vh;margin-right: 10px; margin-left: 10px; margin-top: -185px""
      v-if="allTournaments.length === 0"
      class="align-ver center-hor bg-light"
      :style="{
        backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
        borderRadius: '10px'
      }"
    >
      <div
        style="display: flex; justify-content: center; align-items: center; width: 100%"
      >
        <img src="@/assets/no-data.svg" style="width: 24%;" />
      </div>

      <div style="font-weight: 900; margin-top: 20px;">
        No Tournament Live!
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import OverlapHeader from "@/components/overlapped-header";
import axios from "axios";
export default {
  mixins: [globals],
  components: {
    "header-o": OverlapHeader
  },
  data() {
    return {
      page: 1,
      all_tournaments: [],
      has_no_tournaments: false,
      headerData: {
        onlyHeader: true
        // quizHistory: true,
        // isLeaderBoardHistory: true
      }
    };
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    topBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null;
    },
    allTournaments() {
      return this.all_tournaments;
    },
    hasNoTournaments() {
      return this.has_no_tournaments;
    }
  },
  methods: {
    getGamesData() {
      var self = this;
      var url = this.$store.getters.flyyDomain + "/v2/fetch_tournaments";
      var headers = this.$store.getters.headers;
      axios
        .get(url, {
          mode: "no-cors",
          headers: headers,
          params: {
            page: this.page
          }
        })
        .then(resp => {
          var data = resp.data;
          if (data.success) {
            var tempArr = [];
            if (data.tournaments.length > 0) {
              data.tournaments.forEach(function(v) {
                // if (v.is_live) {
                //   tempArr.push({
                //     id: v.id,
                //     title: v.title,
                //     total_prize: v.total_prize,
                //     prize_type: v.prize_type,
                //     prize_icon_url: v.prize_icon_url,
                //     game_banner: v.game_banner,
                //     is_live: v.is_live,
                //     ends_at: v.ends_at,
                //     starts_at: v.starts_at,
                //     params: {
                //       partner: self.$store.getters.headers["X-Key"],
                //       contact_number: self.extUid,
                //       game_id: v.game_id
                //     }
                //   });
                // }

                tempArr.push({
                  id: v.id,
                  title: v.title,
                  total_prize: v.total_prize,
                  prize_type: v.prize_type,
                  prize_icon_url: v.prize_icon_url,
                  game_banner: v.game_banner,
                  is_live: v.is_live,
                  ends_at: v.ends_at,
                  starts_at: v.starts_at,
                  params: {
                    partner: self.$store.getters.headers["X-Key"],
                    contact_number: self.extUid,
                    game_id: v.game_id
                  }
                });
              });
              this.all_tournaments = tempArr;
              this.$store.state.allTournamentsList = tempArr;
              this.has_no_tournaments = false;
            } else {
              this.has_no_tournaments = true;
            }
          }
        });
    }
  },
  created() {
    this.$store.state.tournamentStatus = [];
    this.$store.state.showHeader = true;
    this.$store.state.showWallet = false;
    this.$store.state.showHeaderBalance = false;
    this.$store.state.user.headerBalance.show = false;
    this.$store.state.showHistory = true;
    this.$store.state.headTitle = "Game Zone";
    // this.getGamesData();
  },
  mounted() {
    clearInterval(this.$store.state.refreshTournamentTimer);
    clearInterval(this.$store.state.timer);
    this.getGamesData();
    this.getTimerForTimerArray();
  }
};
</script>
<style>
.live-timer {
  top: 5px;
  right: -5px;
  background: #d02828;
}
.game-banner {
  min-height: 165px;
}
</style>
